import { Link } from 'react-router-dom';
import logo from '../../assets/logoMoovicar.png';

function Footer() {
  return (
    <footer style={{ backgroundColor: '#1a1a2e', color: '#ccc' }}>
      {/* Colonnes */}
      <div className="container py-5">
        <div className="row g-4">
          {/* Logo + baseline */}
          <div className="col-12 col-md-4">
            <img
              src={logo}
              alt="Moovicar"
              height="44"
              className="mb-3"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="mb-2" style={{ fontSize: 13, lineHeight: 1.7 }}>
              La plateforme de location de voiture entre particuliers. Déverrouillez votre véhicule
              24h/24 avec l'appli.
            </p>
            <p style={{ fontSize: 12, color: '#888' }}>Tous les trajets sont assurés par AXA.</p>
          </div>

          {/* Plateforme */}
          <div className="col-6 col-md-2">
            <p
              className="fw-semibold text-white mb-3"
              style={{ fontSize: 13, letterSpacing: '0.05em' }}
            >
              PLATEFORME
            </p>
            <ul className="list-unstyled mb-0">
              {[
                { to: '/', label: 'Accueil' },
                { to: '/comment-ca-marche', label: 'Comment ça marche' },
                { to: '/help', label: "Centre d'aide" },
                { to: '/location-voiture', label: 'Louer ma voiture' },
              ].map(({ to, label }) => (
                <li key={to} className="mb-2">
                  <Link
                    to={to}
                    className="text-decoration-none"
                    style={{ fontSize: 13, color: '#aaa' }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Aide & Règles */}
          <div className="col-6 col-md-3">
            <p
              className="fw-semibold text-white mb-3"
              style={{ fontSize: 13, letterSpacing: '0.05em' }}
            >
              AIDE & RÈGLES
            </p>
            <ul className="list-unstyled mb-0">
              {[
                {
                  to: '/comment-ca-marche',
                  label: 'User flows conducteur / hôte',
                },
                { to: '/regles-business', label: 'Règles business' },
                { to: '/etats-reservation', label: 'États de réservation' },
                { to: '/rental-conditions', label: 'Conditions de location' },
              ].map(({ to, label }) => (
                <li key={to} className="mb-2">
                  <Link
                    to={to}
                    className="text-decoration-none"
                    style={{ fontSize: 13, color: '#aaa' }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Légal */}
          <div className="col-6 col-md-2">
            <p
              className="fw-semibold text-white mb-3"
              style={{ fontSize: 13, letterSpacing: '0.05em' }}
            >
              LÉGAL
            </p>
            <ul className="list-unstyled mb-0">
              {[
                { to: '/conditions-generales', label: 'CGU & Conditions générales' },
                { to: '/privacy', label: 'Politique de confidentialité' },
                { to: '/cookies', label: 'Cookies' },
              ].map(({ to, label }) => (
                <li key={to} className="mb-2">
                  <Link
                    to={to}
                    className="text-decoration-none"
                    style={{ fontSize: 13, color: '#aaa' }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Barre bas */}
      <div className="border-top" style={{ borderColor: '#333 !important' }}>
        <div className="container py-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
          <span style={{ fontSize: 12, color: '#666' }}>
            © {new Date().getFullYear()} Moovicar, Inc. Tous droits réservés.
          </span>
          <div className="d-flex gap-3">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: '#666', fontSize: 18 }}
            >
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: '#666', fontSize: 18 }}
            >
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
